import { getComponentByBlock } from "@/lib/utils";
import { IBlock, PulseComponent } from "@pulsex/types";
import * as React from "react";

export default function Block({ block, isMobile, pagePostId }: { block: IBlock, isMobile:boolean, pagePostId?: string }) {
    if (!block.widgets?.length) return;
    const pulseComponent: PulseComponent = getComponentByBlock(block);
    if (!pulseComponent) return;
    const { Component, props } = pulseComponent;

    return (
        <>
            <div className="hidden" data-style={block.id} />
            <Component key={block.id} block={block} isMobile={isMobile} pagePostId={pagePostId} {...(props || {})} />
        </>
    );
}
